import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withPillNavigation from '../shared/withPillNavigation.decorator';
import TaxExpenseDraftBanner from '../reports/viewTaxExpensePage/draftBanner.component';
import Spinner from '../shared/spinner.component';
import Report from '../shared/report/report.component';

const TaxExpensePillTypes = {
  US_SUMMARY: 'US_SUMMARY',
  US_TED: 'US_TED',
  US_STATE: 'US_STATE',
  TED_NON_US_GAAP: 'TED_NON_US_GAAP',
  TED_NON_US_STAT: 'TED_NON_US_STAT',
};

const TaxExpenseReportPillDefinitions = [
  { label: 'US Summary', type: TaxExpensePillTypes.US_SUMMARY },
  { label: 'US Federal', type: TaxExpensePillTypes.US_TED },
  { label: 'US State', type: TaxExpensePillTypes.US_STATE },
  { label: 'GAAP Non-US', type: TaxExpensePillTypes.TED_NON_US_GAAP },
  { label: 'STAT Non-US', type: TaxExpensePillTypes.TED_NON_US_STAT },
];

class TaxExpenseReportTab extends PureComponent {
  static propTypes = {
    activePill: PropTypes.oneOf(Object.values(TaxExpensePillTypes)),
    taxExpense: PropTypes.shape({
      US_TED: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
      TED_NON_US_GAAP: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
      TED_NON_US_STAT: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
      US_SUMMARY: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
      US_STATE: PropTypes.objectOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
    }).isRequired,
    isProformaCalc: PropTypes.bool,
  };

  render() {
    const { activePill, taxExpense, isProformaCalc } = this.props;

    if (!taxExpense || !taxExpense[activePill] || !taxExpense[activePill].showReport) {
      return (
        <div className="tax-expense-report-tab">
          <div className="py-4 text-center">No Rows To Show</div>
        </div>
      );
    }

    const reportData = ({
      [TaxExpensePillTypes.US_SUMMARY]: taxExpense.US_SUMMARY,
      [TaxExpensePillTypes.US_TED]: taxExpense.US_TED,
      [TaxExpensePillTypes.US_STATE]: taxExpense.US_STATE,
      [TaxExpensePillTypes.TED_NON_US_GAAP]: taxExpense.TED_NON_US_GAAP,
      [TaxExpensePillTypes.TED_NON_US_STAT]: taxExpense.TED_NON_US_STAT,
    })[activePill];

    const taxExpenseLoading = false;
    const disableDrillLink = true;
    const shouldShowDraftBanner = false;
    const showExpandCollapseAllButton = true;
    const reportTitlePrefix = '';
    return (
      taxExpense && activePill && (
        <div className="ag-grid-full-page-with-secondary-menu">
          {!taxExpenseLoading && shouldShowDraftBanner ? <TaxExpenseDraftBanner /> : null}
          {(taxExpenseLoading || isProformaCalc) && <Spinner/>}
          {!taxExpenseLoading && !isProformaCalc && reportData
            && (
              <Report
                data={reportData}
                sectionHeaderPrefix={reportTitlePrefix}
                useCustomDecimalNumber
                closePopupsOnScroll
                useHistorical={false}
                disableDrillLink={disableDrillLink}
                showExpandCollapseAllButton={showExpandCollapseAllButton}
              />
            )
          }
        </div>
      )
    );
  }
}

export default connect(
  ({ provision }) => ({
    taxExpense: provision.general.taxExpense,
    isProformaCalc: provision.general.isProformaCalc,
  })
)(
  withPillNavigation(
    ({ taxExpense }) => !taxExpense
      ? []
      : TaxExpenseReportPillDefinitions.filter(
        pillDefinition => taxExpense[pillDefinition.type].showReport
      )
  )(TaxExpenseReportTab)
);
